module.exports = __webpack_public_path__ + "media/old_images/icon-news-f1b90786.png";